import type { FC, ReactNode } from 'react';
import React from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
type TQueryProviderProps = {
  children: ReactNode;
};
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
});
export const QueryProvider: FC<TQueryProviderProps> = props => <QueryClientProvider {...props} client={queryClient} />;